var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoggedOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM18.6508 18.9576C16.9226 20.61 14.5798 21.625 12 21.625C9.42017 21.625 7.0774 20.61 5.34923 18.9576C6.38306 11.1942 17.6169 11.1942 18.6508 18.9576ZM19.794 17.6486C19.0319 14.7235 16.9579 12.8882 14.5497 12.1426C15.7761 11.3201 16.5833 9.92098 16.5833 8.33333C16.5833 5.80203 14.5313 3.75 12 3.75C9.46869 3.75 7.41666 5.80203 7.41666 8.33333C7.41666 9.92098 8.2239 11.3201 9.45032 12.1426C7.04205 12.8882 4.96813 14.7235 4.20597 17.6486C3.05421 16.0622 2.375 14.1104 2.375 12C2.375 6.68426 6.68426 2.375 12 2.375C17.3157 2.375 21.625 6.68426 21.625 12C21.625 14.1104 20.9458 16.0622 19.794 17.6486ZM12 11.5417C13.7719 11.5417 15.2083 10.1052 15.2083 8.33333C15.2083 6.56142 13.7719 5.125 12 5.125C10.2281 5.125 8.79167 6.56142 8.79167 8.33333C8.79167 10.1052 10.2281 11.5417 12 11.5417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedOut);
export default __webpack_public_path__ + "static/media/LoggedOut.cb00deee3b90727d7727ae087ce2268c.svg";
export { ForwardRef as ReactComponent };